/**
 * フォーム統計のビジュアルスタイル プリセット (5種類)。
 * v3.1.4
 */
import type { FormAnalyticsVisualStyle } from '@goenhub/shared';

export interface VisualStylePreset {
  /** 表示名 */
  label: string;
  /** 簡単な説明 */
  description: string;
  /** チャート用カラーパレット (recharts に渡す) */
  palette: string[];
  /** カードの背景色 */
  cardBackground: string;
  /** カードの枠線色 */
  cardBorder: string;
  /** タイトル文字色 */
  titleColor: string;
  /** 本文文字色 */
  textColor: string;
  /** font-family (CSS 値) */
  fontFamily: string;
  /** チャートのグリッド線色 */
  gridColor: string;
}

export const VISUAL_STYLES: Record<FormAnalyticsVisualStyle, VisualStylePreset> = {
  minimal: {
    label: 'ミニマル',
    description: 'モノクロ + アクセント1色。シンプルで読みやすい。',
    palette: ['#2b2b2b', '#666', '#aaa', '#d0d0d0', '#4a7cff', '#1a1a1a'],
    cardBackground: '#ffffff',
    cardBorder: '#e5e5e5',
    titleColor: '#111111',
    textColor: '#444444',
    fontFamily: '"DM Sans", "Noto Sans JP", sans-serif',
    gridColor: '#eeeeee',
  },
  vivid: {
    label: 'ビビッド',
    description: '鮮やかな色彩。プレゼン向き。',
    palette: ['#ff4d6d', '#ffa630', '#ffd60a', '#06d6a0', '#118ab2', '#9d4edd'],
    cardBackground: '#fffaf3',
    cardBorder: '#ffd5a8',
    titleColor: '#1a1a1a',
    textColor: '#333333',
    fontFamily: '"DM Sans", "Noto Sans JP", sans-serif',
    gridColor: '#f4dfc1',
  },
  pastel: {
    label: 'パステル',
    description: '柔らかい色合い。プリント物にも合う。',
    palette: ['#a8dadc', '#f4a4b3', '#f6cf94', '#cdb4db', '#bee1e6', '#ffd6a5'],
    cardBackground: '#fdf6f0',
    cardBorder: '#e5dccc',
    titleColor: '#3a3a3a',
    textColor: '#5a5a5a',
    fontFamily: '"Quicksand", "Noto Sans JP", sans-serif',
    gridColor: '#ece2d6',
  },
  dark: {
    label: 'ダーク',
    description: 'ネオン系。暗背景で映える。',
    palette: ['#00f5d4', '#9b5de5', '#f15bb5', '#fee440', '#00bbf9', '#fb5607'],
    cardBackground: '#11151c',
    cardBorder: '#2a2f3a',
    titleColor: '#e8eaef',
    textColor: '#9aa3b2',
    fontFamily: '"DM Sans", "Noto Sans JP", sans-serif',
    gridColor: '#1f242e',
  },
  natural: {
    label: 'ナチュラル',
    description: 'アースカラー。落ち着いた印象。',
    palette: ['#588157', '#a3b18a', '#dad7cd', '#bc6c25', '#dda15e', '#3a5a40'],
    cardBackground: '#f6f3ee',
    cardBorder: '#d6cfc1',
    titleColor: '#283d2a',
    textColor: '#4a5648',
    fontFamily: '"Inter", "Noto Sans JP", sans-serif',
    gridColor: '#e0d8c6',
  },
};

export function resolveStyle(
  style: FormAnalyticsVisualStyle | undefined | null,
): VisualStylePreset {
  return VISUAL_STYLES[style ?? 'minimal'] ?? VISUAL_STYLES.minimal;
}
